import { useDispatch, useSelector } from "react-redux";
import { setFilter, clearFilter } from "../../store/actions/FilterActions";

/**
 * Reemplaza useState para filtros de listados.
 * Persiste el estado en el Redux store (en memoria, sin serializar a disco)
 * durante la sesión del tab. Al recargar la página los filtros se limpian.
 *
 * Los campos InputAutoComplete gestionan su propia caché de visualización
 * internamente (sessionStorage["ac_<id>"]), por lo que este hook solo
 * necesita persistir los valores del filtro (UUIDs, fechas, etc.).
 *
 * La key debe ser única por página/listado (ej: "cargo", "service", "delay").
 */
const useFilterState = (key, defaultValue = undefined) => {
  const dispatch = useDispatch();
  const value = useSelector((state) => state.filters[key]);

  const current = value !== undefined ? value : defaultValue;

  const setFilterState = (newValue) => {
    if (newValue === undefined || newValue === null) {
      dispatch(clearFilter(key));
    } else {
      dispatch(setFilter(key, newValue));
    }
  };

  return [current, setFilterState];
};

export default useFilterState;
